// Firebase app init. The web config (including apiKey) is PUBLIC by design —
// it identifies the project, it is not a secret. Access is secured by Firebase
// Auth + Firestore security rules, not by hiding these values.

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { initializeFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyCkxGBhof0UB9239khMfAq7cbttYxsgLTU',
  authDomain: 'livenearby-ai.firebaseapp.com',
  projectId: 'livenearby-ai',
  storageBucket: 'livenearby-ai.firebasestorage.app',
  messagingSenderId: '528701017731',
  appId: '1:528701017731:web:7e9d01dc821ab9f7ea15b6',
  measurementId: 'G-RREVHVMGWG',
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// ignoreUndefinedProperties: our snapshot has optional fields (e.g.
// formattedAddress) that can be undefined — Firestore rejects undefined unless
// we tell it to drop them.
export const db = initializeFirestore(app, { ignoreUndefinedProperties: true });
